'use strict';

import { getVueTemplate } from '../../../_imports/utils/utils.common';
import BaseVueComponent from '../../../_imports/shared/base-vue-component.vue.common';
import AbstractVideoEndMessage from './abstract-video-end-message.vue.js';
import VideoEndMessageWithResource from './video-end-message-with-resource.vue.js';

export default {
    template: getVueTemplate('video-end-message'),
    mixins: [
        BaseVueComponent,
    ],
    components: {
        AbstractVideoEndMessage,
        VideoEndMessageWithResource
    },
    props: {
        currentVideo: Object,
    },
    data() {
        return {
            isVisible: false,
            videoPlayer: null,
        }
    },
    computed: {
        message() {
            return this.data;
        }
    },
    watch: {
        videoPlayer() {
            if (this.videoPlayer) {
                this.videoPlayer.innerPlayer.bind('end', () => {
                    this.isVisible = true;
                    this.videoPlayer.pause();
                });
            }
        },
    },
    created() {
        CoveoWebsite.videoApi.onReady(this.currentVideo.videoCode, (player) => {
            this.videoPlayer = player;
        });
    },
};